import React, { Component } from 'react'

import CustomInput from '../../components/CustomInput/CustomInput';
import CustomerBlock from '../../components/Customers/CustomerBlock';
import Card from "components/Card/Card.jsx";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import { ButtonBase } from '@material-ui/core';
import AddCustomerModal from './AddCustomerModal';

class CustomerList extends Component {

    state = {
        searchTerm: '',
        add_customer: ''
    }

    render() {
        var filteredAccounts = [];

        if (!this.state.searchTerm) {
            filteredAccounts = this.props.accounts;
        } else {
            const searchExp = new RegExp(this.state.searchTerm, 'ig');
            filteredAccounts = this.props.accounts.filter(value => (searchExp.test(value.name) || searchExp.test(value.account_no)));
        }

        return (
            <div style={{ padding: 20 }}>
                <CustomInput
                    labelText={
                        <span style={{ fontSize: 17 }}>
                            Search Customers...
                        </span>
                    }
                    id="search_customers"
                    formControlProps={{
                        fullWidth: true,
                        variant: "outlined",
                    }}
                    inputProps={{
                        autoFocus: true,
                        variant: "outlined",
                        value: this.state.searchTerm,
                        onChange: (e) => this.setState({ searchTerm: e.target.value }),
                        style: { fontSize: 17 }
                    }}
                />
                {/* TODO: Add Customer Option */}
                <div style={{ position: 'relative', width: '100%' }}>
                    <Card
                        Component={ButtonBase}
                        style={{ height: 64, display: 'flex', flex: 1, justifyContent: 'center', alignItems: 'center', marginTop: 0, marginBottom: 0 }}
                        onClick={() => this.setState({ add_customer: true })}
                    >
                        <FontAwesomeIcon icon={faPlus} size={"3x"} color="#bbb" />
                    </Card>
                </div>

                <AddCustomerModal
                    isOpen={this.state.add_customer}
                    onClose={() => this.setState({ add_customer: false })}
                    existing_customers={this.props.accounts}
                    product_id={this.props.product_id}
                    refresh={() => this.props.refresh()}
                />

                {
                    filteredAccounts.map(
                        account =>
                            <CustomerBlock
                                key={account.id}
                                account={account}
                                link={`/products/view/${this.props.product_id}/${account.id}`}
                            />
                    )
                }
            </div>
        )
    }
}

export default CustomerList;